import { render } from "./ProductosPorMarca.vue?vue&type=template&id=f63f4f3a"
import script from "./ProductosPorMarca.js?vue&type=script&lang=js&external"
export * from "./ProductosPorMarca.js?vue&type=script&lang=js&external"

import "./ProductosPorMarca.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__